import {useSelector,useDispatch} from 'react-redux'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'
import {
	getAggregatedMetricProgress,
	selectProgressClientId,
	logMetricProgress,
	setAddDataModal,
	selectProgressFilters,
	selectAllAiLogs,
	selectMetricCategories,
	selectProgressStatus,
	selectAllProgress,
	selectProgressById,
	getAllProgressData,
	selectProgressIds,
	selectAddDataModal
} from './slice'

export const useMetricProgressLogger = ()=>{

	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()

	const log = (payload)=>{
		return dispatch(logMetricProgress(payload))
	}

	const statusLog = (payload)=>{
		return statusDispatch(logMetricProgress(payload),'metric data','logg')
	}
	
	return {log,statusLog}
}

export const useAddDataModal = ()=>{
	const {clientId,categoryGroups} = useClientMetricProgressData()
	const {show,date} = useSelector(selectAddDataModal)

	return {show,date,categoryGroups}
}

export const useAddDataModalToggle = ()=>{
	const dispatch = useDispatch()
	const {show} = useAddDataModal()
	const toggle = ()=>{
		dispatch(setAddDataModal({show:!show}))
	}
	return toggle
}

export const useClientMetricProgressData = clientId => {
	const dispatch = useDispatch()
	const currentClientId = useSelector(selectProgressClientId)
	const status = useSelector(selectProgressStatus)
	const data = useSelector(selectAllProgress).sort((a,b)=>(
		a.assessment_name < b.assessment_name ? -1 : 1
	))

	//data grouped by category
	const categoryGroupMap = {}
	data.forEach(d=>{
		const {categorization} = d
		if(!Boolean(categoryGroupMap[categorization.category_id])){
			categoryGroupMap[categorization.category_id] = {
				name:categorization.name,
				id:categorization.category_id,
				metrics:[],
				aiLogs:[]
			}
		}
		categoryGroupMap[categorization.category_id].metrics.push(d.metric_id)
	})

	const aiLogs = useSelector(selectAllAiLogs)
	//create map from category_id to  array of ai_log ids
	const categoryLogsMap = {}
	aiLogs.forEach(aiLog=>{
		categoryGroupMap[aiLog.metric_category_id].aiLogs.push(aiLog)
	})

	const categoryGroups = Object.values(categoryGroupMap).sort(
		(a,b)=>(a.name<b.name?-1:1)
	)

	const ids = useSelector(selectProgressIds)

	if (Boolean(clientId)&&(status==='init'||currentClientId!==clientId)) {
		dispatch(getAllProgressData(clientId))
	}


	return {status,categoryGroups,data,ids,clientId}
}

export const useAggregatedMetricProgress = (months=3)=>{
	const dispatch = useDispatch()
	const {status,data,filters} = useSelector(state=>state.allMetrics.aggregates)
	//default to fetching 3 months back
	if (status==='init'||months!==filters.months) dispatch(getAggregatedMetricProgress(months))
	return {status,data}
}

export const useFilteredClientMetricProgressData = clientId => {
	const filters = useSelector(selectProgressFilters)
	const {status,data,categoryGroups} = useClientMetricProgressData(clientId)

	const filteredData = data.filter( d => {
		const matchesCategory = (
			filters.category === 'all'
			||
			parseInt(d.categorization.category_id) === parseInt(filters.category)
		)
		return matchesCategory
	})

	const filteredIds = filteredData.map( d => d.metric_id )

	const filteredGroups = categoryGroups.filter( c => {
		const matchesCategory = (
			filters.category === 'all'
			||
			parseInt(c.id) === parseInt(filters.category)
		)
		return matchesCategory
	})

	return {status,data:filteredData,ids:filteredIds,filters,categoryGroups:filteredGroups}
}

//don't use this hook if you want filters to apply to the presented data
//instead use: useFilteredMetricProgressData
export const useMetricProgressData = id => useSelector(
	state => selectProgressById(state,id)
)

//applies date range filtering to the selected progress 
export const useFilteredMetricProgressData = id => {
	const {daysBack} = useSelector(selectProgressFilters)
	const metric = useMetricProgressData(id)
	return {
		...metric,
		stats:metric.stats.filter(s=>{
			//-1 is value for all time
			if(daysBack === -1) return true
			const diff = (new Date () - new Date(`${s.date}T00:00:00`))/60/60/24/1000
			return diff <= daysBack
		})
	}
}

//selects a specific metric AND only selects a datapoint
//for a specific date if it has one for that date
export const useDateFilteredProgressData = (id,date)=>{
	const metric = useMetricProgressData(id)
	//add a field to the metric that points to the stat object for the specified
	//date or is false if no datapoint exists
	return {
		...metric,
		dateStat:metric.stats.find( s => s.date === date ) || false
	}
}

export const useMetriceCategories = ()=>useSelector(selectMetricCategories).sort((a,b)=>a.name<b.name?-1:1)